import { fetcher } from "helpers/fetcher";

import { TDuplicateJobListingReq, TDuplicateJobListingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const duplicateJobListing = async (
  payload?: TDuplicateJobListingReq
) => {
  return await fetcher<
    TDuplicateJobListingRes,
    TDuplicateJobListingReq["data"]
  >(ENDPOINT.CORPORATION.DUPLICATE_JOB_LISTING, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.CORPORATION.DUPLICATE_JOB_LISTING.version,
      [API_HEADER.CORP_ID]: payload?.idCorp,
    },
  });
};

export const mutationDuplicateJobListing = async (
  payload?: TDuplicateJobListingReq
) => {
  return (await duplicateJobListing(payload)).data;
};

mutationDuplicateJobListing._key = (payload?: TDuplicateJobListingReq) => [
  ENDPOINT.CORPORATION.DUPLICATE_JOB_LISTING.url,
  payload,
];
